import { List, Print, OutLeaving } from "../Components/index.js";

export default [
    {
        path: "/report/pay-allowance",
        component: List,
        name: "report-pay-allowance.list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/pay-allowance/:id/print",
        component: Print,
        name: "report-pay-allowance.print",
        meta: {
            requiresAuth: true,
        },
    },
];
